import { extend } from '../../vue';
import { NAME_FORM_RADIO } from '../../constants/components';
import { makePropsConfigurable } from '../../utils/props';
import { props as props$1, formRadioCheckMixin } from '../../mixins/form-radio-check';

// --- Props ---

const props = makePropsConfigurable(props$1, NAME_FORM_RADIO);

// --- Main component ---

// @vue/component
const BFormRadio = /*#__PURE__*/extend({
  name: NAME_FORM_RADIO,
  mixins: [formRadioCheckMixin],
  inject: {
    getBvGroup: {
      from: 'getBvRadioGroup',
      default: () => () => null
    }
  },
  props,
  computed: {
    bvGroup() {
      return this.getBvGroup();
    }
  }
});

export { BFormRadio, props };
